import { MutableRefObject, useEffect, useState } from 'react'
import WebApp from '@twa-dev/sdk'

import { scrollToInput } from 'utils'

export const useScrollToOnFocus = (ref: MutableRefObject<any>, scrollToOnFocus?: boolean) => {
  const [focused, setFocused] = useState(false)

  const onFocus = () => {
    setFocused(true)
  }
  const onBlur = () => {
    setFocused(false)
  }

  useEffect(() => {
    const onViewportChange = () => {
      if (scrollToOnFocus && focused) {
        scrollToInput(document.querySelector('.scrollable-layout'), ref.current)
      }
    }

    WebApp.onEvent('viewportChanged', onViewportChange)

    return () => {
      WebApp.offEvent('viewportChanged', onViewportChange)
    }
  }, [focused, scrollToOnFocus])

  return {
    onFocus,
    onBlur,
  }
}
